import { isSelfAuthoredMessageNotification } from '../../../../util/notificationHelpers';
import { BOOKING_COMPLETION_TRANSITIONS } from '../../../../util/bookingReviewNotifications';
import {
  getNotificationTransitionName,
  isFailedPaymentNotification,
  isHiddenPaymentReminderNotification,
  isLegacyCustomerPayoutNotification,
  isLegacyProviderPendingPaymentNotification,
  isSelfInquiryNotification,
} from './notificationEventMeta';

const getCurrentUserId = currentUserOrId => {
  if (!currentUserOrId) {
    return null;
  }

  if (typeof currentUserOrId === 'string') {
    return currentUserOrId;
  }

  return currentUserOrId?.id?.uuid || null;
};

export const isSelfMessageNotification = (notification, currentUserOrId) => {
  if (notification?.type !== 'message.new') {
    return false;
  }

  if (isSelfAuthoredMessageNotification(notification)) {
    return true;
  }

  const currentUserId = getCurrentUserId(currentUserOrId);
  if (!currentUserId) {
    return false;
  }

  const actorUserId = notification?.actorUserId || null;
  const recipientUserId = notification?.recipientUserId || null;

  if (actorUserId && actorUserId === currentUserId) {
    return true;
  }

  if (recipientUserId && recipientUserId !== currentUserId) {
    return true;
  }

  return false;
};

export const isPaymentNotConfirmedNotification = notification => {
  return (
    isHiddenPaymentReminderNotification(notification) ||
    isFailedPaymentNotification(notification) ||
    isLegacyProviderPendingPaymentNotification(notification)
  );
};

export const shouldDisplayNotification = (notification, currentUserOrId) => {
  // Hide previously stored review prompts emitted before the review window.
  const isEarlyReviewPrompt =
    notification?.type === 'booking.updated' &&
    !!(notification?.bookingStartAt || notification?.bookingEndAt) &&
    BOOKING_COMPLETION_TRANSITIONS.has(getNotificationTransitionName(notification));
  return (
    !isEarlyReviewPrompt &&
    !isPaymentNotConfirmedNotification(notification) &&
    !isLegacyCustomerPayoutNotification(notification) &&
    !isSelfInquiryNotification(notification) &&
    !isSelfMessageNotification(notification, currentUserOrId)
  );
};

export const filterDisplayableNotifications = (notifications, currentUserOrId) => {
  const list = Array.isArray(notifications) ? notifications : [];
  return list.filter(notification => shouldDisplayNotification(notification, currentUserOrId));
};

export const getUnreadCountForDisplayableNotifications = (notifications, currentUserOrId) => {
  return filterDisplayableNotifications(notifications, currentUserOrId).filter(
    item => !item?.isRead
  ).length;
};
